import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable'
import { TranslateService } from '@ngx-translate/core';
import { font, fontArlight } from 'src/assets/fonts/fonts/ar/fontB64';
import { manropeMedium, manropeBold } from 'src/assets/fonts/fonts/en/manropeb64';
import { BehaviorSubject, delay, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
@Injectable({
  providedIn: 'root'
})
export class ChartsExportService {

  pdfWidth = 210;
  pdfHeight = 297;
  y = 0

  addTagOnBodyForPrint() {
    const body = document.querySelector('body');
    body.classList.add('printing');
  }
  removeTagOnBodyForPrint() {
    const body = document.querySelector('body');
    body.classList.remove('printing');
  }


  private isExporting = new BehaviorSubject<boolean>(false);
  $isExporting = this.isExporting.asObservable()
  set setIsExport(value: boolean) { this.isExporting.next(value) }

  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe,
  ) { }

  async exportAsImage() {
    const fullDOMPage = document.querySelector(".page-content") as HTMLElement;
    htmlToImage.toJpeg(fullDOMPage)
      .then(function (dataUrl) {
        let link: HTMLAnchorElement = document.createElement("a");
        link['download'] = "report";
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
  }

  async exportAllChartsToImage(dateRange: any) {
    this.setIsExport = true
    const selectedLang = this.translate.currentLang
    const userString = localStorage.getItem('loggedinUser')
    const loggedInUser = userString ? JSON.parse(userString) : null
    const doc = new jsPDF();
    let details: any = []
    if (selectedLang === 'en') {
      doc.addFileToVFS('Manrope-Medium.ttf', manropeMedium);
      doc.addFileToVFS('Manrope-Bold.ttf', manropeBold);
      doc.addFont('Manrope-Medium.ttf', 'Manrope-Medium', 'normal');
      doc.addFont('Manrope-Bold.ttf', 'Manrope-Bold', 'bold');
      doc.setFont('Manrope-Medium');
      details = [
        [{ content: "Name", colSpan: 2, }, { content: `${loggedInUser.given_name} ${loggedInUser.family_name}`, colSpan: 4 }], // First row with 2 columns
        ["Issue Date", new Date().toLocaleString(), "Start Date", new Date(dateRange.startDate).toLocaleDateString(), "End Date", new Date(dateRange.endDate).toLocaleDateString()] // Second row with 6 columns
      ];
    } else {
      doc.addFileToVFS('HelveticaNeueLTArabic-Bold.ttf', font)
      doc.addFileToVFS('HelveticaNeueLTArabic-normal.ttf', fontArlight)
      doc.addFont('HelveticaNeueLTArabic-normal.ttf', 'HelveticaNeueLTArabic-Normal', 'normal');
      doc.addFont('HelveticaNeueLTArabic-Bold.ttf', 'HelveticaNeueLTArabic-Bold', 'bold');
      doc.setFont('HelveticaNeueLTArabic-Normal');
      details = [
        [{ content: "الاسم", colSpan: 2, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: loggedInUser?.arabicName, colSpan: 4, styles: { halign: 'right' } }].reverse(),
        [{ content: "تاريخ الإصدار", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date().toLocaleTimeString() + ", " + new Date().toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
        { content: "تاريخ البدء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.startDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
        { content: "تاريخ الانتهاء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.endDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
        ].reverse(),
      ];
    }

    const pdfWidth = 210;
    const pdfHeight = 297;

    let img = new Image()
    img.src = 'assets/images/logo-color.png'
    setTimeout(async () => {
      const captureElement = document.querySelector("#pro") as HTMLElement;
      const cases = document.querySelector(".cases-row") as HTMLElement;
      const custType = document.querySelector(".customer-type-category") as HTMLElement;
      const cusCat = document.querySelector(".customer-cat-sub-cat") as HTMLElement;
      const tDemo = document.querySelector(".transaction-demographic") as HTMLElement;
      const tCenter = document.querySelector(".transaction-center") as HTMLElement;

      if (tCenter) {
        let y = 0;
        const casesCanvas = await html2canvas(tCenter)

        let aspectRatio = casesCanvas.width / casesCanvas.height;
        let imgWidth = pdfWidth;
        let imgHeight = pdfWidth / aspectRatio;
        let logoWidth = 50
        let logoHeight = 15
        const pageWidth = doc.internal.pageSize.getWidth();

        const marginX = (pageWidth - casesCanvas.width) / 2;

        if (imgHeight > pdfHeight) {
          imgHeight = pdfHeight - 25;
          imgWidth = pdfHeight * aspectRatio;
        }
        const logox = (pdfWidth - 50) / 2;
        doc.addImage(img, 'PNG', logox, 5, logoWidth, logoHeight)
        doc.setFontSize(10)
        const textX = 10
        const textY = logoHeight + 10
        autoTable(doc, {
          startY: textY,
          body: details,

          didParseCell: function (data) {
            if (
              data.row.index === 0 ||
              data.cell.raw === "Issue Date" ||
              data.cell.raw === "Start Date" ||
              data.cell.raw === "End Date"

            ) {
              data.cell.styles.fontStyle = "bold";
            } else if (
              data.row.index === 0 ||
              data.cell.raw === "تاريخ الإصدار" ||
              data.cell.raw === "تاريخ البدء" ||
              data.cell.raw === "تاريخ الانتهاء"

            ) {
              data.cell.styles.font = "HelveticaNeueLTArabic-Bold";
              // data.cell.styles.fontStyle = 'bold'
              // data.cell.styles = 'left'
            }
          },
          showHead: false,
          styles: {
            overflow: "linebreak",
            font: "HelveticaNeueLTArabic-Bold",
            // cellWidth:'auto'
          },
          theme: "grid",
          bodyStyles: {
            font: selectedLang === 'en' ? "Manrope-Medium" : "HelveticaNeueLTArabic-Normal"
          },

          columnStyles: {
            Name: { fontStyle: "bold" }
          },
        })
        y = textY + 25

        const custTypeCanvas = await html2canvas(custType)
        aspectRatio = custTypeCanvas.width / custTypeCanvas.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(custTypeCanvas, 'PNG', 10, y, imgWidth - 5, imgHeight)
        y = y + imgHeight + 15

        const cusCatCanvas = await html2canvas(cusCat)
        aspectRatio = cusCatCanvas.width / cusCatCanvas.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(cusCatCanvas, 'PNG', 10, y - 10, imgWidth - 5, imgHeight)
        y = y + imgHeight + 10

        const transactionDemoCanvas = await html2canvas(tDemo)
        doc.addPage()
        y = 10
        aspectRatio = transactionDemoCanvas.width / transactionDemoCanvas.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(transactionDemoCanvas, 'PNG', 10, y, imgWidth - 5, imgHeight)
        y = y + imgHeight + 10

        const transactionCenterCanvas = await html2canvas(tCenter)
        aspectRatio = transactionCenterCanvas.width / transactionCenterCanvas.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(transactionCenterCanvas, 'PNG', 10, y, imgWidth - 5, imgHeight)
        doc.save('adca-reporting')
        this.setIsExport = false;

      }
    }, 1000)
  }

  async exportAllmarketingChartsToImage(dateRange: any) {
    this.setIsExport = true
    setTimeout(async () => {
      const selectedLang = this.translate.currentLang
      const userString = localStorage.getItem('loggedinUser')
      const loggedInUser = userString ? JSON.parse(userString) : null
      const doc = new jsPDF();
      let details: any = []
      if (selectedLang === 'en') {
        doc.addFileToVFS('Manrope-Medium.ttf', manropeMedium);
        doc.addFileToVFS('Manrope-Bold.ttf', manropeBold);

        doc.addFont('Manrope-Medium.ttf', 'Manrope-Medium', 'normal');
        doc.addFont('Manrope-Bold.ttf', 'Manrope-Bold', 'bold');

        doc.setFont('Manrope-Medium');
        details = [
          [{ content: "Name", colSpan: 2, }, { content: `${loggedInUser.given_name} ${loggedInUser.family_name}`, colSpan: 4 }], // First row with 2 columns
          ["Issue Date", new Date().toLocaleString(), "Start Date", new Date(dateRange.startDate).toLocaleDateString(), "End Date", new Date(dateRange.endDate).toLocaleDateString()] // Second row with 6 columns
        ];
      } else {
        doc.addFileToVFS('HelveticaNeueLTArabic-Bold.ttf', font)
        doc.addFileToVFS('HelveticaNeueLTArabic-normal.ttf', fontArlight)

        doc.addFont('HelveticaNeueLTArabic-normal.ttf', 'HelveticaNeueLTArabic-Normal', 'normal');
        doc.addFont('HelveticaNeueLTArabic-Bold.ttf', 'HelveticaNeueLTArabic-Bold', 'bold');

        doc.setFont('HelveticaNeueLTArabic-Normal');
        details = [
          [{ content: "الاسم", colSpan: 2, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: loggedInUser?.arabicName, colSpan: 4, styles: { halign: 'right' } }].reverse(),
          [{ content: "تاريخ الإصدار", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date().toLocaleTimeString() + ", " + new Date().toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
          { content: "تاريخ البدء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.startDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
          { content: "تاريخ الانتهاء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.endDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
          ].reverse(),
        ];
      }

      const pdfWidth = this.pdfWidth;
      const pdfHeight = this.pdfHeight;

      let img = new Image()
      img.src = 'assets/images/logo-color.png'
      // const allCountsTopBoxes = document.querySelector("#allcounts") as HTMLElement;
      const fullDOMPage = document.querySelector(".page-content") as HTMLElement;
      const allCountsElement = document.querySelector("#allcounts") as HTMLElement;
      const tabCharts = document.querySelector("#tabCharts") as HTMLElement;
      const demographic = document.querySelector(".demographic-map") as HTMLElement;
      const segments = document.querySelector(".mrk-segments") as HTMLElement;
      const journeys = document.querySelector(".mrk-journeys") as HTMLElement;
      if (allCountsElement) {
        // console.log(allCountsElement);
        let logoWidth = 50
        let logoHeight = 15
        let y = 0
        fullDOMPage.style.width = '1691';
        const allCountsElem = await html2canvas(allCountsElement);
        //   html2canvas(document.getElementById('content'), { scale: 1, width: 2000, height: 9000 }).then(canvas => {
        //             var imgData = canvas.toDataURL("image/jpeg");
        //             var pdf = new jsPDF('p', 'mm', [520, 1080]);
        //             pdf.addImage(imgData, 'JPEG', 10, 10);
        //             
        //             pdf.save("Test.pdf");
        //           });
        // html2canvas(allCountsElement).then((canvas) => {
        let aspectRatio = allCountsElem.width / allCountsElem.height;
        let imgWidth = pdfWidth;
        let imgHeight = pdfWidth / aspectRatio;

        if (imgHeight > pdfHeight) {
          imgHeight = pdfHeight - 25;
          imgWidth = pdfHeight * aspectRatio;
        }
        const logox = (pdfWidth - 50) / 2;
        doc.addImage(img, 'PNG', logox, 5, logoWidth, logoHeight)
        doc.setFontSize(10)
        const textX = 10
        const textY = logoHeight + 10

        autoTable(doc, {
          startY: textY,
          body: details,
          didParseCell: function (data) {
            if (
              data.row.index === 0 ||
              data.cell.raw === "Issue Date" ||
              data.cell.raw === "Start Date" ||
              data.cell.raw === "End Date"
            ) {
              data.cell.styles.fontStyle = "bold";
            } else if (
              data.row.index === 0 ||
              data.cell.raw === "تاريخ الإصدار" ||
              data.cell.raw === "تاريخ البدء" ||
              data.cell.raw === "تاريخ الانتهاء"
            ) {
              data.cell.styles.font = "HelveticaNeueLTArabic-Bold";
              // data.cell.styles.fontStyle = 'bold'
              // data.cell.styles = 'left'
            }
          },
          showHead: false,
          styles: {
            overflow: "linebreak",
            cellWidth: 'auto'
            // font: selectedLang === 'en' ? "Manrope-Medium" : "HelveticaNeueLTArabic-Normal"
          },
          theme: "grid",
          bodyStyles: {
            font: selectedLang === 'en' ? "Manrope-Medium" : "HelveticaNeueLTArabic-Normal"
          },

          columnStyles: {
            Name: { fontStyle: "bold" },
          },
        })
        doc.addImage(allCountsElem, 'PNG', 5, textY + 23, imgWidth - 10, imgHeight)
        // const dataUrl = allCountsElem.toDataURL("png");
        // console.log(dataUrl);
        y = y + imgHeight + 35
        if (document.querySelector('.page-content.dashobard-content .card-row-mb .col-3:nth-child(4) .cases-values-wrap .mat-card')) {
        } else {
        }

        const tabsCharts = await html2canvas(tabCharts);
        aspectRatio = tabsCharts.width / tabsCharts.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        y = y + 10
        doc.addImage(tabsCharts, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight

        const demographicCharts = await html2canvas(demographic);
        doc.addPage()
        y = 10
        aspectRatio = demographicCharts.width / demographicCharts.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(demographicCharts, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const segmentsChart = await html2canvas(segments);
        // if(window.innerWidth < 1450){
        doc.addPage()
        y = 10
        // }
        aspectRatio = segmentsChart.width / segmentsChart.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(segmentsChart, 'PNG', 5, y - 8, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const journeysCharts = await html2canvas(journeys);
        // if(!(window.innerWidth < 1450)){
        //   doc.addPage()
        //   y = 10
        // }

        aspectRatio = journeysCharts.width / journeysCharts.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(journeysCharts, 'PNG', 5, y, imgWidth, imgHeight)
        doc.save('adca-reporting')
        fullDOMPage.style.width = fullDOMPage.style.width;
        this.setIsExport = false

      }
    }, 1000);

  }

  async exportTabsAsPdf(dateRange: any) {
    let doc = new jsPDF()
    doc = this.createHeader(doc, dateRange)

    const tabCharts = document.querySelector("#tabCharts") as HTMLElement;
    const canvas = await html2canvas(tabCharts)//.then((canvas)=>{})
    const aspectRatio = canvas.width / canvas.height;
    let imgWidth = this.pdfWidth - 15;
    let imgHeight = 150 //this.pdfHeight / aspectRatio;
    doc.addImage(canvas, 'PNG', 10, this.y, imgWidth, imgHeight)
    await doc.save("adca-reporting")
    return

  }

  async exportJourneyAnalyticsEmailAsPDF(dateRange: any) {
    let doc = new jsPDF()
    doc = this.createHeader(doc, dateRange)

    const tabCharts = document.querySelector("#email-tab-content-wrapper") as HTMLElement;
    const canvas = await html2canvas(tabCharts)//.then((canvas)=>{})
    const aspectRatio = canvas.width / canvas.height;
    let imgWidth = this.pdfWidth - 10;
    let imgHeight = this.pdfHeight / aspectRatio;
    doc.addImage(canvas, 'PNG', 10, this.y, imgWidth, imgHeight)
    await doc.save("adca-reporting")
    return
  }

  async exportJourneyAnalyticsSmsAsPDF(dateRange: any) {
    let doc = new jsPDF()
    doc = this.createHeader(doc, dateRange)

    const tabCharts = document.querySelector("#sms-tab-content-wrapper") as HTMLElement;
    const canvas = await html2canvas(tabCharts)//.then((canvas)=>{})
    const aspectRatio = canvas.width / canvas.height;
    let imgWidth = this.pdfWidth - 10;
    let imgHeight = this.pdfHeight / aspectRatio;
    doc.addImage(canvas, 'PNG', 10, this.y, imgWidth, imgHeight)
    await doc.save("adca-reporting")
    return
  }

  async exportDemographicAsPdf(dateRange: any) {
    let doc = new jsPDF()
    doc = this.createHeader(doc, dateRange)
    const demographic = document.querySelector(".mrk-demogrpahics") as HTMLElement;
    const canvas = await html2canvas(demographic)
    const aspectRatio = canvas.width / canvas.height;
    let imgWidth = this.pdfWidth - 10;
    let imgHeight = this.pdfWidth / aspectRatio;
    doc.addImage(canvas, 'PNG', 10, this.y, imgWidth, imgHeight)
    await doc.save("adca-reporting")

    return

  }

  async exportSegmentsAsPdf(dateRange: any) {
    let doc = new jsPDF()
    doc = this.createHeader(doc, dateRange)
    const segments = document.querySelector(".mrk-segments") as HTMLElement;
    const canvas = await html2canvas(segments)
    const aspectRatio = canvas.width / canvas.height;
    let imgWidth = this.pdfWidth - 10;
    let imgHeight = this.pdfWidth / aspectRatio;
    doc.addImage(canvas, 'PNG', 10, this.y, imgWidth, imgHeight)
    doc.save("adca-reporting")
    return
  }

  async exportJourneyAsPdf(dateRange: any, data) {
    const selectedLang = this.translate.currentLang

    let doc = new jsPDF()
    doc = this.createHeader(doc, dateRange)
    if (selectedLang === 'en') {
      let body = data.map(obj => [obj?.JourneyName, obj?.Segment, obj?.ChannelType, this.formatDate(obj?.DateAndTime), obj?.Status])
      let head = ['Journey Name', 'Segment', 'Channel Type', 'Created On', 'Status']
      autoTable(doc, {
        head: [head],
        body: body,
        styles: {
          overflow: "visible",
          font: "HelveticaNeueLTArabic-Bold"
        },
        headStyles: {
          fillColor: [192, 192, 192],
          fontSize: 12,
        },
        bodyStyles: {
          font: "HelveticaNeueLTArabic-Bold"
        },
      })
    }
    else {
      // let head = ['الحالة', 'أنشئت على', 'تصنيف القناة', 'الشرائح', 'اسم الرحلة']
      let head = ["اسم الرحلة", "الشرائح", "تصنيف القناة", "أنشئت على", "الحالة"]
      head.reverse()
      let body = data.map(obj => [this.translation(obj?.Status), this.formatDate(obj?.DateAndTime), this.translation(obj?.ChannelType), obj?.Segment, obj?.JourneyName,])

      doc.addFileToVFS('HelveticaNeueLTArabic-Bold-normal.ttf', font);
      doc.addFont('HelveticaNeueLTArabic-Bold-normal.ttf', 'HelveticaNeueLTArabic-Bold', 'normal');
      doc.setFont('HelveticaNeueLTArabic-Bold');
      autoTable(doc, {
        head: [head],
        body: body,
        styles: {
          overflow: "visible",
          font: "HelveticaNeueLTArabic-Bold"
        },
        headStyles: {
          fillColor: [192, 192, 192],
          fontSize: 12,
        },
        bodyStyles: {
          font: "HelveticaNeueLTArabic-Bold"
        },
      })
    }
    doc.save('adca-reporting')
    return
  }

  async exportAllCaseManagementChartsToImage(dateRange: any) {
    this.setIsExport = true
    setTimeout(async () => {
      const selectedLang = this.translate.currentLang
      const userString = localStorage.getItem('loggedinUser')
      const loggedInUser = userString ? JSON.parse(userString) : null
      const doc = new jsPDF();
      let details: any = []
      if (selectedLang === 'en') {
        doc.addFileToVFS('Manrope-Medium.ttf', manropeMedium);
        doc.addFileToVFS('Manrope-Bold.ttf', manropeBold);

        doc.addFont('Manrope-Medium.ttf', 'Manrope-Medium', 'normal');
        doc.addFont('Manrope-Bold.ttf', 'Manrope-Bold', 'bold');

        doc.setFont('Manrope-Medium');
        details = [
          [{ content: "Name", colSpan: 2, }, { content: `${loggedInUser.given_name} ${loggedInUser.family_name}`, colSpan: 4 }],
          ["Issue Date", new Date().toLocaleString(), "Start Date", new Date(dateRange.startDate).toLocaleDateString(), "End Date", new Date(dateRange.endDate).toLocaleDateString()] // Second row with 6 columns
        ];
      }
      else {
        doc.addFileToVFS('HelveticaNeueLTArabic-Bold.ttf', font)
        doc.addFileToVFS('HelveticaNeueLTArabic-normal.ttf', fontArlight)

        doc.addFont('HelveticaNeueLTArabic-normal.ttf', 'HelveticaNeueLTArabic-Normal', 'normal');
        doc.addFont('HelveticaNeueLTArabic-Bold.ttf', 'HelveticaNeueLTArabic-Bold', 'bold');

        doc.setFont('HelveticaNeueLTArabic-Normal');
        details = [
          [{ content: "الاسم", colSpan: 2, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: loggedInUser?.arabicName, colSpan: 4, styles: { halign: 'right' } }].reverse(),
          [{ content: "تاريخ الإصدار", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date().toLocaleTimeString() + ", " + new Date().toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
          { content: "تاريخ البدء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.startDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
          { content: "تاريخ الانتهاء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.endDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
          ].reverse(),
        ];
      }

      const pdfWidth = this.pdfWidth;
      const pdfHeight = this.pdfHeight;

      let img = new Image()
      img.src = 'assets/images/logo-color.png'
      const fullDOMPage = document.querySelector(".page-content") as HTMLElement;
      const caseTypeCount = document.querySelector(".cases-types") as HTMLElement;
      const caseStatusType = document.querySelector(".cases-status-types") as HTMLElement;
      const caseDet = document.querySelector(".cases-details") as HTMLElement;
      const pMatrics1 = document.querySelector(".performance-matrices-1") as HTMLElement;
      const pMatrics2 = document.querySelector(".performance-matrices-2") as HTMLElement;
      const cInsight = document.querySelector(".customer-insight") as HTMLElement;
      const custComm = document.querySelector(".customer-communication") as HTMLElement;
      const compAnalysis = document.querySelector(".complaint-analysis") as HTMLElement;
      const servIns1 = document.querySelector(".service-insight-1") as HTMLElement;
      const servIns2 = document.querySelector(".service-insight-2") as HTMLElement;
      const advAnaly = document.querySelector(".advanced-analytics") as HTMLElement;
      const knowMang = document.querySelector(".knowledge-management") as HTMLElement;

      if (caseTypeCount) {
        let logoWidth = 50
        let logoHeight = 15
        let y = 0
        fullDOMPage.style.width = '1691';
        const allCountsElem = await html2canvas(caseTypeCount);
        let aspectRatio = allCountsElem.width / allCountsElem.height;
        let imgWidth = pdfWidth;
        let imgHeight = pdfWidth / aspectRatio;

        if (imgHeight > pdfHeight) {
          imgHeight = pdfHeight - 25;
          imgWidth = pdfHeight * aspectRatio;
        }
        const logox = (pdfWidth - 50) / 2;
        doc.addImage(img, 'PNG', logox, 5, logoWidth, logoHeight)
        doc.setFontSize(10)
        const textX = 10
        const textY = logoHeight + 10

        autoTable(doc, {
          startY: textY,
          body: details,
          didParseCell: function (data) {
            if (
              data.row.index === 0 ||
              data.cell.raw === "Issue Date" ||
              data.cell.raw === "Start Date" ||
              data.cell.raw === "End Date"
            ) {
              data.cell.styles.fontStyle = "bold";
            } else if (
              data.row.index === 0 ||
              data.cell.raw === "تاريخ الإصدار" ||
              data.cell.raw === "تاريخ البدء" ||
              data.cell.raw === "تاريخ الانتهاء"
            ) {
              data.cell.styles.font = "HelveticaNeueLTArabic-Bold";
              // data.cell.styles.fontStyle = 'bold'
              // data.cell.styles = 'left'
            }
          },
          showHead: false,
          styles: {
            overflow: "linebreak",
            cellWidth: 'auto'
            // font: selectedLang === 'en' ? "Manrope-Medium" : "HelveticaNeueLTArabic-Normal"
          },
          theme: "grid",
          bodyStyles: {
            font: selectedLang === 'en' ? "Manrope-Medium" : "HelveticaNeueLTArabic-Normal"
          },

          columnStyles: {
            Name: { fontStyle: "bold" },
          },
        })
        doc.addImage(allCountsElem, 'PNG', 5, textY + 18, imgWidth - 10, imgHeight)
        y = y + imgHeight + 35

        const caseStatusTypeCharts = await html2canvas(caseStatusType);
        aspectRatio = caseStatusTypeCharts.width / caseStatusTypeCharts.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        y = y + 10
        doc.addImage(caseStatusTypeCharts, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight

        const caseDetailCharts = await html2canvas(caseDet);
        doc.addPage()
        y = 10
        aspectRatio = caseDetailCharts.width / caseDetailCharts.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(caseDetailCharts, 'PNG', 5, y - 10, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const matricsChart1 = await html2canvas(pMatrics1);
        doc.addPage()
        y = 10
        aspectRatio = matricsChart1.width / matricsChart1.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(matricsChart1, 'PNG', 5, y - 10, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const matricsChart2 = await html2canvas(pMatrics2);
        doc.addPage()
        y = 10
        aspectRatio = matricsChart2.width / matricsChart2.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(matricsChart2, 'PNG', 5, y - 10, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const casesInsightChart = await html2canvas(cInsight);
        doc.addPage()
        y = 10
        aspectRatio = casesInsightChart.width / casesInsightChart.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(casesInsightChart, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const customerCommunicationChart = await html2canvas(custComm);
        doc.addPage()
        y = 10
        aspectRatio = customerCommunicationChart.width / customerCommunicationChart.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(customerCommunicationChart, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const complaintAnalysisChart = await html2canvas(compAnalysis);
        doc.addPage()
        y = 10
        aspectRatio = complaintAnalysisChart.width / complaintAnalysisChart.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(complaintAnalysisChart, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const servInsightChart1 = await html2canvas(servIns1);
        doc.addPage()
        y = 10
        aspectRatio = servInsightChart1.width / servInsightChart1.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(servInsightChart1, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const servInsightChart2 = await html2canvas(servIns2);
        doc.addPage()
        y = 10
        aspectRatio = servInsightChart2.width / servInsightChart2.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(servInsightChart2, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const advanceAnalysisChart = await html2canvas(advAnaly);
        doc.addPage()
        y = 10
        aspectRatio = advanceAnalysisChart.width / advanceAnalysisChart.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(advanceAnalysisChart, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        const knowledgeManangementChart = await html2canvas(knowMang);
        doc.addPage()
        y = 10
        aspectRatio = knowledgeManangementChart.width / knowledgeManangementChart.height;
        imgWidth = pdfWidth - 10;
        imgHeight = pdfWidth / aspectRatio;
        doc.addImage(knowledgeManangementChart, 'PNG', 5, y, imgWidth, imgHeight)
        y = y + imgHeight + 10

        doc.save('adca-reporting')
        fullDOMPage.style.width = fullDOMPage.style.width;
        this.setIsExport = false

      }
    }, 1000);
  }

  createHeader(doc: jsPDF, dateRange) {
    const selectedLang = this.translate.currentLang
    const userString = localStorage.getItem('loggedinUser')
    const loggedInUser = userString ? JSON.parse(userString) : null
    // const doc = new jsPDF();
    let details: any = []
    if (selectedLang === 'en') {
      doc.addFileToVFS('Manrope-Medium.ttf', manropeMedium);
      doc.addFileToVFS('Manrope-Bold.ttf', manropeBold);
      doc.addFont('Manrope-Medium.ttf', 'Manrope-Medium', 'normal');
      doc.addFont('Manrope-Bold.ttf', 'Manrope-Bold', 'bold');

      doc.setFont('Manrope-Medium');
      details = [
        [{ content: "Name", colSpan: 2, }, { content: `${loggedInUser.given_name} ${loggedInUser.family_name}`, colSpan: 4 }], // First row with 2 columns
        ["Issue Date", new Date().toLocaleString(), "Start Date", new Date(dateRange.startDate).toLocaleDateString(), "End Date", new Date(dateRange.endDate).toLocaleDateString()] // Second row with 6 columns
      ];
    } else {
      doc.addFileToVFS('HelveticaNeueLTArabic-Bold.ttf', font)
      doc.addFileToVFS('HelveticaNeueLTArabic-normal.ttf', fontArlight)

      doc.addFont('HelveticaNeueLTArabic-normal.ttf', 'HelveticaNeueLTArabic-Normal', 'normal');
      doc.addFont('HelveticaNeueLTArabic-Bold.ttf', 'HelveticaNeueLTArabic-Bold', 'bold');

      doc.setFont('HelveticaNeueLTArabic-Normal');
      details = [
        [{ content: "الاسم", colSpan: 2, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: loggedInUser?.arabicName, colSpan: 4, styles: { halign: 'right' } }].reverse(),
        [{ content: "تاريخ الإصدار", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date().toLocaleTimeString() + ", " + new Date().toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
        { content: "تاريخ البدء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.startDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
        { content: "تاريخ الانتهاء", colSpan: 1, styles: { halign: 'right', font: 'HelveticaNeueLTArabic-Bold' } }, { content: new Date(dateRange.endDate).toLocaleDateString(), colSpan: 1, styles: { halign: 'right' } },
        ].reverse(),
      ];
    }
    let logoWidth = 50
    let logoHeight = 15
    const pdfWidth = 210;
    const pdfHeight = 297;
    const textY = logoHeight + 5
    const logox = (pdfWidth - 50) / 2;

    let img = new Image()
    img.src = 'assets/images/logo-color.png'
    doc.addImage(img, 'PNG', logox, 5, logoWidth, logoHeight)
    doc.setFontSize(10)

    autoTable(doc, {
      startY: textY,
      body: details,
      didParseCell: function (data) {
        if (
          data.row.index === 0 ||
          data.cell.raw === "Issue Date" ||
          data.cell.raw === "Start Date" ||
          data.cell.raw === "End Date"
        ) {
          data.cell.styles.fontStyle = "bold";
        } else if (
          data.row.index === 0 ||
          data.cell.raw === "تاريخ الإصدار" ||
          data.cell.raw === "تاريخ البدء" ||
          data.cell.raw === "تاريخ الانتهاء"
        ) {
          data.cell.styles.font = "HelveticaNeueLTArabic-Bold";
          // data.cell.styles.fontStyle = 'bold'
          // data.cell.styles = 'left'
        }
      },
      showHead: false,
      styles: {
        overflow: "linebreak",
        cellWidth: 'auto'
        // font: "HelveticaNeueLTArabic-Bold"
      },
      theme: "grid",
      bodyStyles: {
        font: selectedLang === 'en' ? "Manrope-Medium" : "HelveticaNeueLTArabic-Normal"
      },
      columnStyles: {
        Name: { fontStyle: "bold" },
      },
    })
    this.y = (doc as any).lastAutoTable.finalY + 10
    return doc
  }

  formatDate(dateString: any) {
    if (dateString == null) {
      return null;
    }
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  translation(key: any) {
    if (!key || key == null || key == '') {
      return null;
    }
    let translatedKey;
    this.translate.get(key).subscribe((data: any) => {
      translatedKey = data
    })
    return translatedKey
  }
}
